export const environment = {
  name: 'qual',

  production: true,
  localTranslations: false,

  apiDomain: 'qual-commandesante.bizzdev.net',
  apiUrl: 'https://qual-commandesante.bizzdev.net/api/',
  identityApiUrl: 'https://qual-commandesante.bizzdev.net/identity/',

  tokenKey: 'token',
  tokenExpKey: 'token-exp',
  rfTokenKey: 'rf-token',

  appName: "Qual Commande santé",

  version: require('../../package.json').version,
  build: require('../../package.json').build
};
